import firebase from 'firebase';
import _ from 'lodash';

import View from '../../_components/view/view.js';
import playersTpl from './players.tpl.html';
import './players.styles.less';

import PlayerView from './player/player.view.js';

class PlayersView extends View {

	constructor (data, options) {
		super(playersTpl, data, options);

		this.playerViews = [];
		this.playersRef = firebase.database().ref('players/');
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			playersList: '.players-list',
			btnAddPlayer: '.btn-add-player',
			btnEditPlayer: '.btn-edit-player',
			btnCancelEdit: '.btn-cancel-edit-player',
			inputName: 'input[name="name"]',
			inputSurname: 'input[name="surname"]'
		});
	}

	render(data) {
		super.render(data);
		this.initializePlayersData();
	}

	initializePlayersData() {
		this.playersRef.on('value', __players => {
			this.updatePlayersList(__players);
		});
	}

	initializeEvents() {
		super.initializeEvents();
		
		this.ui.btnAddPlayer.click(() => this.addPlayer());
		this.ui.btnEditPlayer.click(() => this.updatePlayer());
		this.ui.btnCancelEdit.click(() => this.hideEditPlayer());
	}

	updatePlayersList(__players) {
		this.removePlayersList();

		__players.forEach( __player => {
			let
			playerView = new PlayerView(__player.val(), {__player: __player});
			playerView.on('edit:player', this.showEditPlayer.bind(this));
			this.playerViews.push(playerView);
			playerView.appendTo(this.ui.playersList);
		});
	}

	removePlayersList() {
		_.forEach(this.playerViews, playerView => {
			playerView.remove();
			playerView.off('edit:player');
		});

		this.playerViews = [];
	}

	showEditPlayer(__player) {
		let playerData = __player.val();
		this.editPlayerRef = __player.ref;

		this.ui.inputName.val(playerData.name);
		this.ui.inputSurname.val(playerData.surname);
		this.ui.btnAddPlayer.hide();
		this.ui.btnEditPlayer.show();
		this.ui.btnCancelEdit.show();
	}

	addPlayer() {
		firebase.database().ref('players/').push({
			name: this.ui.inputName.val(),
			surname: this.ui.inputSurname.val()
		})
		.then(() => this.cleanForm());
	}

	updatePlayer() {
		this.editPlayerRef.update({
			name: this.ui.inputName.val(),
			surname: this.ui.inputSurname.val()
		})
		.then(() => {
			this.hideEditPlayer();
		});
	}

	hideEditPlayer() {
		this.cleanForm();
		this.ui.btnEditPlayer.hide();
		this.ui.btnCancelEdit.hide();
		this.ui.btnAddPlayer.show();
	}

	cleanForm() {
		this.ui.inputName.val('');
		this.ui.inputSurname.val('');
	}

	/*onShow() {

	}*/


	remove() {
		super.remove();
	}

}

export default PlayersView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/players/players.view.js